import { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import './ProjectDetails.css';
import heroImg from '../../assets/hero-home-image.png';

// Import amenity icons
import icon1 from '../../assets/icons/1.png';
import icon2 from '../../assets/icons/2.png';
import icon3 from '../../assets/icons/3.png';
import icon4 from '../../assets/icons/4.png';
import icon5 from '../../assets/icons/5.png';
import icon6 from '../../assets/icons/6.png';
import icon7 from '../../assets/icons/7.png';
import icon8 from '../../assets/icons/8.png';

// Import mobile nav icons
import mn1 from '../../assets/icons/MN/Overview.png';
import mn2 from '../../assets/icons/MN/Amenties 1.png';
import mn3 from '../../assets/icons/MN/gallary 1.png';
import mn5 from '../../assets/icons/MN/video 1.png';
import mn6 from '../../assets/icons/MN/maps-and-flags 1.png';
import mn7 from '../../assets/icons/MN/call 1.png';



// Import gallery images
import gallery1 from '../../assets/gallary/img1.png';
import gallery2 from '../../assets/gallary/img2.jpg';
import gallery3 from '../../assets/gallary/img3.jpg';
import gallery4 from '../../assets/gallary/img4.jpg';
import gallery5 from '../../assets/gallary/img5.jpg';
import gallery6 from '../../assets/gallary/img6.jpeg';
import gallery7 from '../../assets/gallary/img7.jpg';
import gallery8 from '../../assets/gallary/img8.jpg';
import gallery9 from '../../assets/gallary/img9.jpg';
import gallery10 from '../../assets/gallary/img10.jpg';

// Import floor plan images
import floorplan1 from '../../assets/floorplan/img1.jpg';
import floorplan2 from '../../assets/floorplan/img2.jpg';
import floorplan3 from '../../assets/floorplan/img3.jpg';
import floorplan4 from '../../assets/floorplan/img4.jpg';
import floorplan5 from '../../assets/floorplan/img5.jpg';
import floorplan6 from '../../assets/floorplan/img6.jpg';
import floorplan7 from '../../assets/floorplan/img7.jpg';
import floorplan8 from '../../assets/floorplan/img8.jpg';
import floorplan9 from '../../assets/floorplan/img9.jpg';
import floorplan10 from '../../assets/floorplan/img10.jpg';

const ProjectDetails = () => {
    const [activeSection, setActiveSection] = useState('overview');
    const [activeSet, setActiveSet] = useState<'gallery' | 'floorPlans' | null>(null);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    // Scroll Spy Effect
    useEffect(() => {
        const sections = ['overview', 'amenities', 'gallery', 'plans', 'videos', 'location', 'inquiry'];

        const handleScroll = () => {
            const scrollPosition = window.scrollY + 150; // Offset for header/nav height

            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const galleryImages = [
        { src: gallery1, alt: "Badminton Court" },
        { src: gallery2, alt: "Snooker Room" },
        { src: gallery3, alt: "Multipurpose Hall" },
        { src: gallery4, alt: "Table Tennis" },
        { src: gallery5, alt: "Gym Area" },
        { src: gallery6, alt: "Yoga Room" },
        { src: gallery7, alt: "Swimming Pool" },
        { src: gallery8, alt: "Kids Play Area" },
        { src: gallery9, alt: "Lobby" },
        { src: gallery10, alt: "Clubhouse" }
    ];

    const floorPlanImages = [
        { src: floorplan1, alt: "Master Plan" },
        { src: floorplan2, alt: "Ground Floor Plan" },
        { src: floorplan3, alt: "1st Floor Plan" },
        { src: floorplan4, alt: "2nd Floor Plan" },
        { src: floorplan5, alt: "3rd Floor Plan" },
        { src: floorplan6, alt: "4th Floor Plan" },
        { src: floorplan7, alt: "5th Floor Plan" },
        { src: floorplan8, alt: "Terrace Plan" },
        { src: floorplan9, alt: "Parking Layout" },
        { src: floorplan10, alt: "Elevation View" }
    ];

    const currentImages = activeSet === 'gallery' ? galleryImages : floorPlanImages;

    const scrollToSection = (id: string) => {
        setActiveSection(id);
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div className="property-details-page">

            {/* HERO SECTION */}
            <section className="details-hero" style={{ backgroundImage: `url(${heroImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="details-hero-content">
                    <h1 className="head1">Coral Residency</h1>
                    <p className="head1">Vellanapatti, Coimbatore.</p>
                </div>
            </section>

            {/* MINI NAV BAR (Desktop) */}
            <div className="mini-nav-wrapper desktop-only">
                <ul className="mini-nav">
                    {['Overview', 'Amenities', 'Gallery', 'Plans', 'Videos', 'Location', 'Inquiry'].map((item) => (
                        <li
                            key={item}
                            className={activeSection === item.toLowerCase() ? 'active' : ''}
                            onClick={() => scrollToSection(item.toLowerCase())}
                        >
                            {item}
                        </li>
                    ))}
                </ul>
            </div>

            {/* MOBILE BOTTOM NAV BAR */}
            <div className="mobile-bottom-nav mobile-only">
                <div className={`nav-item ${activeSection === 'overview' ? 'active' : ''}`} onClick={() => scrollToSection('overview')}>
                    <span className="nav-icon">
                        <img src={mn1} alt="" />
                    </span>
                    <span className="nav-label">Overview</span>
                </div>
                <div className={`nav-item ${activeSection === 'amenities' ? 'active' : ''}`} onClick={() => scrollToSection('amenities')}>
                    <span className="nav-icon">
                        <img src={mn2} alt="" />
                    </span>
                    <span className="nav-label">Amenities</span>
                </div>
                <div className={`nav-item ${activeSection === 'gallery' ? 'active' : ''}`} onClick={() => scrollToSection('gallery')}>
                    <span className="nav-icon">
                        <img src={mn3} alt="" />
                    </span>
                    <span className="nav-label">Gallery</span>
                </div>

                <div className={`nav-item ${activeSection === 'videos' ? 'active' : ''}`} onClick={() => scrollToSection('videos')}>
                    <span className="nav-icon"><img src={mn5} alt="" /></span>
                    <span className="nav-label">Videos</span>
                </div>
                {/* Skipping Videos to save space if needed, but let's try to fit all or scroll */}

                <div className={`nav-item ${activeSection === 'location' ? 'active' : ''}`} onClick={() => scrollToSection('location')}>
                    <span className="nav-icon"><img src={mn6} alt="" /></span>
                    <span className="nav-label">Location</span>
                </div>
                <div className={`nav-item ${activeSection === 'inquiry' ? 'active' : ''}`} onClick={() => scrollToSection('inquiry')}>
                    <span className="nav-icon"><img src={mn7} alt="" /></span>
                    <span className="nav-label">Inquiry</span>
                </div>
            </div>

            {/* OVERVIEW SECTION */}
            <section className="overview-section" id="overview">
                {/* OVERVIEW HEADER */}
                <div className="overview-header">
                    <h2 className="head1">Overview</h2>
                </div>

                {/* OVERVIEW CONTENT */}
                <Row gutter={[20, 20]}>
                    {/* LEFT CONTENT */}
                    <Col xs={24} lg={14} className="overview-left">
                        <p className="overview-intro">
                            <span className="dropcap">C</span>oral Residency<br />
                            Homes that exceed your expectations. Privileges that surpass them.
                            At Coral Residency, your home is more than four walls — it’s a statement
                            of elegance and aspiration. Every detail inspires, every space elevates,
                            and every privilege redefines luxury. Step into a world where expectations
                            aren’t just met, but exceeded
                        </p>

                        <p>
                            A Landmark Address in Peelamedu <br />
                            Set on Vilankurichi Road, Luminare places you at the epicenter of Coimbatore’s growth. With top IT parks minutes away — including the upcoming Globus Arima Cloudscape IT Park — your life stays seamlessly connected to work, learning, and lifestyle.
                            Schools, hospitals, and retail hubs are all within reach, making this not just a home, but a smart investment.
                        </p>

                        <p>
                            Celebrate a Privileged Life Life here is elevated living. Dive into the pool, recharge with a game of badminton,
                            or relax in the exclusive clubhouse — every day is a celebration of privilege and comfort.
                        </p>

                        <h3>Why Choose Luminare?</h3>

                        <ul className="why-list">
                            <li>Prestigious address in Peelamedu</li>
                            <li>Close to IT parks and schools</li>
                            <li>Premium amenities and clubhouse</li>
                            <li>Thoughtful layouts and quality construction</li>
                            <li>Smart investment with high appreciation potential</li>
                        </ul>

                        <p className="closing-line">
                            Discover a life that exceeds expectations. Discover Luminare.
                        </p>
                    </Col>

                    {/* Right side was empty in legacy layout, preserved grid 1.3fr 0.7fr */}
                    {/* Right side now contains RERA and Details Table */}
                    <Col xs={24} lg={10} className="overview-right">

                        {/* RERA BLOCK */}
                        <div className="rera-block">
                            <div className="rera-icon">R</div>
                            <div className="rera-content">
                                <span>era Registraion No : </span>
                                <strong>TNRERA/11/BLG/0302/2025</strong>
                                <a href="https://rera.tn.gov.in" target="_blank" rel="noopener noreferrer" className="rera-link">
                                    https://rera.tn.gov.in
                                </a>
                            </div>
                        </div>

                        {/* DETAILS TABLE */}
                        <div className="details-table-box">
                            {/* ROW 1 (Header) */}
                            <div className="table-row header-row">
                                <div className="table-cell label">Property Type:</div>
                                <div className="table-cell value">Residential Apartments</div>
                            </div>

                            {/* ROW 2 */}
                            <div className="table-row">
                                <div className="table-cell label">No. of Apartments:</div>
                                <div className="table-cell value">97</div>
                            </div>

                            {/* ROW 3 */}
                            <div className="table-row">
                                <div className="table-cell label">Location:</div>
                                <div className="table-cell value">
                                    375/1B1, 376/1A, Vilankurichi Road, <br />
                                    Peelamedu, Coimbatore - 641004.
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </section>

            {/* BUILT WITH SECTION */}
            <section className="used-section" id="amenities">
                <div className="used-container">
                    <h2 className="head1">Amenities</h2>
                    <span className="title-line"></span>
                    <p className="subtitle">Globus Luminare is your gateway to opulence!</p>

                    <Row gutter={[40, 80]} justify="center">
                        <Col xs={12} sm={12} md={6} lg={6} className="tool">
                            <div className="icon">
                                <img src={icon1} alt="Township Living" />
                            </div>
                            <h4 className="used">Township Living</h4>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} className="tool">
                            <div className="icon"><img src={icon2} alt="International standard Infrastructure" /></div>
                            <h4 className="used">International standard</h4>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} className="tool">
                            <div className="icon"><img src={icon3} alt="Lush greenery and landscaped entry" /></div>
                            <h4 className="used">Lush greenery and landscaped entry</h4>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} className="tool">
                            <div className="icon"><img src={icon4} alt="Ample Parking space" /></div>
                            <h4 className="used">Ample Parking space</h4>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} className="tool">
                            <div className="icon"><img src={icon5} alt="Swimming pool" /></div>
                            <h4 className="used">Swimming pool</h4>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} className="tool">
                            <div className="icon"><img src={icon6} alt="Club house" /></div>
                            <h4 className="used">Club house</h4>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} className="tool">
                            <div className="icon"><img src={icon7} alt="Gymnasium" /></div>
                            <h4 className="used">Gymnasium</h4>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} className="tool">
                            <div className="icon"><img src={icon8} alt="Indoor Games" /></div>
                            <h4 className="used">Indoor Games</h4>
                        </Col>
                    </Row>
                </div>
            </section>


            {/* GALLERY SECTION */}
            <section className="gallery-section" id="gallery">
                <div className="gallery-container">
                    <h2 className="gallery-title">Gallery</h2>

                    <div className="gallery-grid">
                        {galleryImages.map((item, index) => (
                            <div
                                className="gallery-item"
                                key={index}
                                onClick={() => { setActiveSet('gallery'); setSelectedIndex(index); }}
                            >
                                <img src={item.src} alt={item.alt} />
                                <div className="gallery-overlay">
                                    <span>View</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FLOOR PLANS SECTION */}
            <section className="floor-plans-section" id="plans">
                <div className="floor-plans-container">
                    <h2 className="floor-plans-title">Floor Plans</h2>

                    <div className="floor-plans-grid">
                        {floorPlanImages.map((item, index) => (
                            <div
                                className="floor-plan-item"
                                key={index}
                                onClick={() => { setActiveSet('floorPlans'); setSelectedIndex(index); }}
                                style={{ position: 'relative', cursor: 'pointer' }}
                            >
                                <img src={item.src} alt={item.alt} />
                                <div className="gallery-overlay">
                                    <span>View</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* VIDEO SECTION */}
            <section className="video-section" id="videos">
                <div className="video-container">
                    <h2 className="video-title">Video</h2>
                    <div className="video-underline"></div>

                    <div className="video-wrapper">
                        <div className="video-player">
                            {/* YouTube Video Embed */}
                            <iframe
                                src="https://www.youtube.com/embed/W-s7dkhIilw?rel=0&loop=1&playlist=W-s7dkhIilw&modestbranding=1&controls=1"
                                title="Property Walkthrough Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className="video-iframe"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </section>

            {/* LOCATION SECTION */}
            <section className="location-section" id="location">
                <div className="location-container">
                    {/* Title */}
                    <h2 className="location-title">Location</h2>
                    <span className="location-line"></span>

                    {/* Content */}
                    <div className="location-content">
                        {/* MAP */}
                        <div className="location-map">
                            <iframe
                                src="https://www.google.com/maps?q=Globus%20Arima%20Luminare%20Coimbatore&output=embed"
                                title="Map"
                                loading="lazy"
                            ></iframe>
                        </div>

                        {/* INFO PANEL */}
                        <div className="location-info">
                            {/* Address */}
                            <div className="info-block">
                                <h3>Address</h3>
                                <span className="info-line"></span>
                                <p>
                                    Coral Residency<br />
                                    375/1B1, 376/1A, Vilankurichi Road, Peelamedu, Coimbatore - 641 004.
                                </p>
                            </div>

                            {/* Transport */}
                            <div className="info-block">
                                <h3>Key Transport</h3>
                                <span className="info-line"></span>

                                <div className="transport-grid">
                                    <div className="transport-item">AIRPORT:<strong>1 KM</strong></div>
                                    <div className="transport-item">AVINASHI ROAD:<strong>2 KM</strong></div>
                                    <div className="transport-item">KMCH HOSPITAL:<strong>3 KM</strong></div>
                                    <div className="transport-item">COIMBATORE MEDICAL COLLEGE:<strong>4 KM</strong></div>
                                    <div className="transport-item">CODISSIA TRADE FAIR COMPLEX:<strong>5 KM</strong></div>
                                    <div className="transport-item">RAILWAY STATION:<strong>6 KM</strong></div>
                                    <div className="transport-item">TIDEL PARK:<strong>7 KM</strong></div>
                                    <div className="transport-item">PSG COLLEGE:<strong>8 KM</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* INQUIRY SECTION */}
            <section className="inquiry-section" id="inquiry">
                <div className="inquiry-container">
                    <h2 className="inquiry-title">Inquiry</h2>
                    <div className="title-underline-center"></div>
                    <p className="inquiry-subtitle">
                        Wish to get a call back from our team? Fill in your details.
                    </p>

                    <form className="inquiry-form" onSubmit={(e) => e.preventDefault()}>
                        <input type="text" placeholder="Name" className="inquiry-input" />
                        <input type="email" placeholder="Email" className="inquiry-input" />
                        <input type="tel" placeholder="Mobile Number" className="inquiry-input" />
                        <input
                            type="text"
                            value="Coral Residency - Vellanapatti"
                            readOnly
                            className="inquiry-input"
                            style={{ background: 'transparent', color: '#fff', border: '1px solid #ddd' }}
                        />
                    </form>

                    <div className="send-btn-container">
                        <button className="inquiry-send-btn">Send</button>
                    </div>

                    <div className="consent-wrapper">
                        <input type="checkbox" id="consent" />
                        <label htmlFor="consent">
                            Yes, I consent to my data being stored according to the guidelines set out in the
                            <a href="#" className="consent-link"> Privacy Policy</a>.
                        </label>
                    </div>

                    <div className="inquiry-actions">
                        <a href="#" className="action-btn btn-dark">Download Brochure</a>
                        <a href="#" className="action-btn btn-outline">$ Payment Schedule</a>
                    </div>

                    <p className="inquiry-warning">
                        If any of our persons ask for cash payment, kindly call or inform directly at
                        <span className="warning-contact"> +91 95246 23599</span> or raise your complain to
                        <span className="warning-contact"> info@globuse.com</span>
                    </p>

                </div>
            </section>

            {/* LIGHTBOX OVERLAY */}
            {activeSet && selectedIndex !== null && (
                <div className="lightbox" onClick={() => { setActiveSet(null); setSelectedIndex(null); }}>
                    <span className="lightbox-close">&times;</span>

                    {/* Previous Button */}
                    {selectedIndex > 0 && (
                        <button
                            className="lightbox-nav prev"
                            onClick={(e) => { e.stopPropagation(); setSelectedIndex(selectedIndex - 1); }}
                        >
                            &#10094;
                        </button>
                    )}

                    <img
                        className="lightbox-img"
                        src={currentImages[selectedIndex].src}
                        alt={currentImages[selectedIndex].alt}
                        onClick={(e) => e.stopPropagation()}
                    />

                    <h3 className="lightbox-caption" onClick={(e) => e.stopPropagation()}>
                        {currentImages[selectedIndex].alt}
                    </h3>

                    {/* Next Button */}
                    {selectedIndex < currentImages.length - 1 && (
                        <button
                            className="lightbox-nav next"
                            onClick={(e) => { e.stopPropagation(); setSelectedIndex(selectedIndex + 1); }}
                        >
                            &#10095;
                        </button>
                    )}
                </div>
            )}

            {/* Mobile-only footer adjustment style */}
            <style>
                {`
                    @media (max-width: 767px) {
                        .site-footer {
                            padding-bottom: 120px !important;
                        }
                    }
                `}
            </style>

        </div>
    );
};

export default ProjectDetails;
